export enum GoalType {
  REMOVE_BACKGROUND = 'removeBackground',
  IMAGE_CLEANUP = 'imageCleanup',
  PHOTOREALISTIC = 'photorealistic',
}
